import { ImmerStateCreator, Store } from '@/store/type'
import { SegmentSlice, SegmentState } from '@/store/segmentSlice/type'

const initialState: SegmentState = {
    isDetailOpen: false
}

export const useSegmentSlice: ImmerStateCreator<SegmentSlice> = (set) => ({
    state: initialState,
    actions: {
        setDetailOpen: (isOpen) =>
            set((state) => {
                state.segmentSlice.state.isDetailOpen = isOpen
            }), 
        onReset: () =>
            set((state) => {
                state.segmentSlice.state = initialState
            }),
    },
})

export const segmentStateSelector = (state: Store) =>
    state.segmentSlice.state

export const operationActionsSelector = (state: Store) =>
    state.segmentSlice.actions
